export { default as ErrorContent } from './ErrorContent';
export { default as InformationContent } from './InformationContent';
export { default as UpdateDuplicateContent } from './UpdateDuplicateContent';

export type DuplicateIds = {
    label: string;
    key: string;
    value: boolean;
};

export type State = {
    file: File | null;
    errors: string | null;
    updateCount: number | null;
    duplicates: DuplicateIds[] | null;
};

type SetUpdateCount = { type: 'setUpdateCount'; updateCount: number | null };
type SetDuplicates = { type: 'setDuplicates'; duplicates: DuplicateIds[] | null };
type SetErrors = { type: 'setErrors'; errors: string | null };
type SetFile = { type: 'setFile'; file: File | null };
type SetDefaultModal = { type: 'setDefault' };
export type Action = SetUpdateCount | SetDuplicates | SetErrors | SetFile | SetDefaultModal;

export const defaultState = {
    file: null,
    errors: null,
    updateCount: null,
    duplicates: null,
};

export const reducer = (state: State, action: Action): State => {
    switch (action.type) {
        case 'setUpdateCount':
            return { ...state, updateCount: action.updateCount };

        case 'setDuplicates':
            return { ...state, duplicates: action.duplicates };

        case 'setErrors':
            return { ...state, errors: action.errors };

        case 'setFile':
            return { ...state, file: action.file };

        case 'setDefault':
            return { ...defaultState };

        default:
            return state;
    }
};
